import { useTranslation } from "react-i18next";
import { SectionTitle } from "../../components/SettingsComponents/SectionTitle";
import { SystemPreferencesContent } from "../../components/PreferencesComponents/SystemPreferencesContent";

export const SystemPreferences = () => {
  const { t } = useTranslation(["Preferences"]);

  return (
    <>
      <SectionTitle title={t("SystemPreferences.Header")} />
      <div className="et-system-preferences module-layout-content h-100 et-board-list-scrollable-container">
        <div className="m-4 notifications-content">
          <SystemPreferencesContent />
        </div>
      </div>
    </>
  );
};
